import { IVec3, Vec3 } from "@base/math/Vec3";
import { MaterialType } from "@biz/definitions/SunSailDefinitions";
import { PoleLogic } from "./PoleLogic";

export const clampInfos = {
  "00E13001735": { // aluClamp design
    offset: Vec3.from(0.005, 0, -0.075)
  },
  "00E13000219": { // aluClamp
    offset: Vec3.from(0.0025, 0, -0.092)
  },
  "00E13001734": { // steelClamp design
    offset: Vec3.from(0.005, 0, -0.067)
  },
  "00E13000103": { // steelClamp
    offset: Vec3.from(0.0025, -0.00, -0.091)
  },
  "00E13000211": { // droppoleClamp standard
    offset: Vec3.from(0, 0, -0.09)
  },
  "00E13001787": { // droppoleClamp design
    offset: Vec3.from(0, 0, -0.095)
  }
} satisfies Record<string, { offset: IVec3 }>


export class ClampLogic {
  static isClampArticleId(articleId: string): boolean {
    return !!(clampInfos as any)[articleId]
  }

  static calcDesignClamp(material: MaterialType): string | undefined {
    if (PoleLogic.isAlu(material))
      return "00E13001735";
    else if (PoleLogic.isSteel(material))
      return "00E13001734";
    else if (PoleLogic.isDroppole(material))
      return "00E13001787";

    return undefined;
  }
  static calcClampArticleIds(material: MaterialType): string[] {
    if (PoleLogic.isAlu(material))
      return ["00E13001735", "00E13000219"];
    else if (PoleLogic.isSteel(material))
      return ["00E13001734", "00E13000103"];
    else if (PoleLogic.isDroppole(material))
      return ["00E13001787", /*"00E13000211",*/];

    return [];
  }

  static calcClampMountOffset(articleId: string): IVec3 {
    if (!articleId)
      return Vec3.ZERO;
    return clampInfos[articleId as keyof typeof clampInfos]?.offset || Vec3.ZERO;
  }

  static calcArticleForMaterial(material: MaterialType, slotArticle: string | undefined): string {
    const articleIds = ClampLogic.calcClampArticleIds(material);
    if (articleIds.length === 0)
      return "";
    if (slotArticle) {
      if (articleIds.includes(slotArticle))
        return slotArticle;
    }
    return articleIds[0];
  }
}